import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ListViewTypes } from '../listViewTypes';
import { TableColumnConfig } from '../table.columns';
import { Router } from '@angular/router';


@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class TableComponent implements OnInit {
  @Input() pageSize = 1;
  @Input() columnConfigs: TableColumnConfig[];
  @Input() items: any[];
  @Input() emptyMessage: string;
  @Input() isLoading: boolean;
  @ViewChild('customCellTemplate', { static: true })
  customCellTemplate: TemplateRef<any>;
  @ViewChild('cardCustomCellTemplate', { static: true })
  cardCustomCellTemplate: TemplateRef<any>;
  @Input() enableSelection = false;
  @Input() listViewTypes: ListViewTypes;
  isTableView: boolean = true;
  isTemplateCard: boolean = false;
  selectedRow: any;
  @Output() onSelectRow= new EventEmitter<any>();
  @Input() showCursorOnRow: boolean=false;

  ShowMore:boolean = false;
  constructor(public router: Router) {
  }

  ngOnInit() {
    this.isTableView = (this.listViewTypes === ListViewTypes.table);
    this.isTemplateCard = (this.listViewTypes === ListViewTypes.template);
  }

  selectRow(row: any) {
    this.selectedRow = row;
    this.onSelectRow.emit(row);
  }


  ShowMoreDetails() {
    this.ShowMore = !this.ShowMore;
  }

}
